import styled from "styled-components";

export const BackupUserContainer = styled.div`
  height: 100%;
`;

export const BackupContainer = styled.div`
  height: 100%;
`;

export const ContentsBody = styled.div`
  background-color: white;
  border-radius: 1.2rem;
  height: calc(100% - 6rem);
  padding: 3rem;
  overflow: hidden scroll;
  position: relative;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3rem;
    .total {
      font-size: 1.6rem;
      color: #555;
      font-weight: 500;
    }
    .sort {
      .search-select {
        font-size: 1.4rem;
      }
    }
  }

  .top-contents {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3rem;
    .total {
      margin-bottom: 0;
    }
    .btn-box {
      display: flex;
      gap: 16px;
      button {
        min-width: 15.4rem;
        font-size: 1.6rem;
        font-weight: 400;
        letter-spacing: -0.05rem;
        color: white;
        border: none;
        outline: none;
        border-radius: 0.6rem;
        padding: 1rem;
        opacity: 0.6;

        &.regist {
          background-color: #30a690;
        }
        &.modify {
          background-color: #2d2d2d;
        }
        &.delete {
          background-color: #ffab40;
        }
        &:hover {
          opacity: 1;
        }
        &:active {
          transform: scale(0.97);
        }
      }
      .report-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .pdf-download-button {
          min-width: 11.2rem;
          height: 3.8rem;
          border: 1px solid #30a690;
          border-radius: 0.6rem;
          background-color: #30a690;
          color: white;
          font-size: 1.5rem;
          font-weight: 600;
          cursor: pointer;
          &:hover {
            background-color: #258d7a;
          }
          &:disabled {
            border-color: #c7d8d5;
            background-color: #c7d8d5;
            cursor: not-allowed;
          }
        }
      }
    }
  }
  .top-components {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3rem;
    .l {
      display: flex;
      align-items: center;
      gap: 0.8rem;
      label {
        font-size: 1.6rem;
        font-weight: 400;
        color: #555;
        transform: translateY(1px);
      }
      input {
        width: 1.6rem;
        height: 1.6rem;
      }
    }
    .r {
      button {
        width: 15.4rem;
        height: 3.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        outline: none;
        border: 0;
        background-color: #ffab40;
        color: white;
        font-size: 1.6rem;
        line-height: 1;
        letter-spacing: -0.05rem;
        border-radius: 0.6rem;
        opacity: 0.6;
        &:active {
          transform: scale(0.97);
        }
        &:hover {
          opacity: 1;
        }
        &:disabled {
          transform: scale(1);
          background-color: #eee;
          color: #555;
          opacity: 1;
        }
      }
    }
  }
  .hr {
    height: 2px;
    background-color: #ebebeb;
    width: calc(100% + 6rem);
    margin: 0 -3rem;
  }
  .loading,
  .no-data {
    padding: 2rem;
    text-align: center;
    font-size: 1.6rem;
    border: 1px solid #ececec;
    border-radius: 0.6rem;
  }
  .backup-date-list {
    padding: 3rem 0;
    .backup-date-root {
      border: 1px solid #30a690;
      border-radius: 1.2rem;
      overflow: hidden;
      .top-components {
        margin-bottom: 0;
        padding: 2rem 3rem;
        background-color: #30a690;
        .l {
          label {
            color: white;
            word-break: break-all;
          }
        }
      }
      .backup-date-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 1.6rem 3rem;
        border-bottom: 1px solid #ebebeb;
        border-top: 0;
        border-left: 0;
        border-right: 0;
        background-color: white;
        cursor: pointer;
        text-align: left;
        p {
          font-size: 1.6rem;
          color: #555;
          font-weight: 500;
        }
        span {
          font-size: 1.4rem;
          color: #6d6d6d;
        }
        &:last-child {
          border-bottom: 0;
        }
        &:hover {
          background-color: #f8fbfa;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding: 1.6rem;
    height: auto;
    .top-components {
      margin-bottom: 1.6rem;
      .r {
        button {
          width: 7rem;
        }
      }
    }
    .backup-date-list {
      padding: 2rem 0;
      .backup-date-root {
        .top-components {
          padding: 1.6rem;
        }
        .backup-date-item {
          align-items: flex-start;
          flex-direction: column;
          gap: 0.8rem;
          padding: 1.6rem;
        }
      }
    }
  }
`;

export const UserListConponents = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 2rem;
  .list-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    border: 2px solid #eee;
    border-radius: 0.6rem;
    cursor: pointer;
    flex-direction: column;
    gap: 0.4rem;
    span.user-account {
      font-size: 1.6rem;
      font-weight: bold;
    }
    span.user-name {
      font-size: 1.4rem;
      font-weight: 500;
    }
    &:hover {
      border: 2px solid #30a690;
    }
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
    .list-item {
      span {
        font-size: 1.4rem;
      }
    }
  }
`;

export const DeviceListContainer = styled.div`
  padding: 3rem 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4rem;
  .device-items {
    border: 1px solid #30a690;
    border-radius: 1.2rem;
    overflow: hidden;
    .device-item {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      padding: 2rem 3rem;
      background-color: #30a690;
      .input-box {
        display: flex;
        align-items: center;
        gap: 1rem;
        input {
          width: 1.6rem;
          height: 1.6rem;
        }
        label {
          font-size: 1.6rem;
          font-weight: 400;
          transform: translateY(1px);
          color: white;
        }
      }
      .view-backup {
        button {
          outline: none;
          border: 0;
          background-color: #0e322b;
          color: white;
          width: 10.8rem;
          height: 3.6rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 0.6rem;
          font-size: 1.6rem;
          letter-spacing: -0.05rem;
          line-height: 1;
          padding-top: 3px;
          opacity: 0.6;
          &:active {
            transform: scale(0.97);
          }
          &:hover {
            opacity: 1;
          }
        }
      }
    }
    .info {
      padding: 1.6rem 3.6rem 2.4rem;
      .device-info {
        margin-bottom: 1.2rem;
        p {
          font-size: 1.6rem;
          color: #555;
          line-height: 1.5;
          letter-spacing: -0.05rem;
          font-weight: 400;
        }
      }
      .user-info {
        background-color: #ebebeb;
        padding: 0.8rem;
        display: flex;
        justify-content: center;
        border-radius: 0.6rem;
        align-items: center;
        gap: 0.8rem;
        span {
          font-size: 1.2rem;
          color: #6d6d6d;
          line-height: 1.5;
          font-weight: 400;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding: 2rem 0;
    grid-template-columns: repeat(1, 1fr);
    .device-items {
      .device-item {
        padding: 2rem 1rem;
        flex-direction: column;
        gap: 1.2rem;
        align-items: flex-start;
        .input-box {
          gap: 0.4rem;
        }
        .view-backup {
          width: 100%;
          button {
            width: 100%;
            font-size: 1.4rem;
          }
        }
      }
      .info {
        padding: 2rem;
        .user-info {
          flex-direction: column;
          span:nth-child(even) {
            display: none;
          }
        }
      }
    }
  }
`;

export const BackupFolderContainer = styled.div``;

export const FolderListContainer = styled.div`
  padding: 3rem 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4rem;
  .folder-items {
    border: 1px solid #30a690;
    border-radius: 1.2rem;
    overflow: hidden;
    .folder-item {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      padding: 2rem 3rem;
      background-color: #30a690;
      .input-box {
        display: flex;
        align-items: center;
        gap: 1rem;
        input {
          width: 1.6rem;
          height: 1.6rem;
        }
        label {
          font-size: 1.6rem;
          font-weight: 400;
          transform: translateY(1px);
          color: white;
        }
      }
      .view-backup {
        button {
          outline: none;
          border: 0;
          background-color: #0e322b;
          color: white;
          width: 10.8rem;
          height: 3.6rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 0.6rem;
          font-size: 1.6rem;
          letter-spacing: -0.05rem;
          line-height: 1;
          padding-top: 3px;
          opacity: 0.6;
          &:active {
            transform: scale(0.97);
          }
          &:hover {
            opacity: 1;
          }
        }
      }
    }
    .info {
      padding: 1.6rem 3.6rem 2.4rem;
      .folder-info {
        margin-bottom: 1.2rem;
        p {
          font-size: 1.6rem;
          color: #555;
          line-height: 1.5;
          letter-spacing: -0.05rem;
          font-weight: 400;
        }
      }
      .user-info {
        background-color: #ebebeb;
        padding: 0.8rem;
        display: flex;
        justify-content: center;
        border-radius: 0.6rem;
        align-items: center;
        gap: 0.8rem;
        span {
          font-size: 1.2rem;
          color: #6d6d6d;
          line-height: 1.5;
          font-weight: 400;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding: 2rem 0;
    grid-template-columns: repeat(1, 1fr);
    .folder-items {
      .folder-item {
        padding: 2rem 1rem;
        flex-direction: column;
        gap: 1.2rem;
        .input-box {
          label {
            word-break: break-all;
          }
        }
        .view-backup {
          width: 100%;
          button {
            width: 100%;
          }
        }
      }
      .info {
        padding: 2rem;
      }
    }
  }
`;

export const BackupFileListContainer = styled.div`
  .contents-top {
    border: 1px solid #30a690;
    border-radius: 1.2rem;
    overflow: hidden;
    display: flex;
    height: 8rem;
    align-items: stretch;
    margin-bottom: 2.4rem;
    .device-name {
      min-width: 40rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #30a690;
      p {
        color: white;
        font-size: 2.4rem;
        font-weight: bold;
        letter-spacing: -0.05rem;
        line-height: 1.5;
      }
    }
    .device-info {
      display: flex;
      padding: 2.4rem 3.6rem;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      p {
        font-size: 1.6rem;
        line-height: 1.5;
        letter-spacing: -0.05rem;
        color: #555;
        font-weight: 500;
      }
      .user-info {
        padding: 0.8rem 1.6rem;
        display: flex;
        gap: 0.8rem;
        border-radius: 0.6rem;
        background-color: #ebebeb;
        span {
          font-size: 1.4rem;
          color: #6d6d6d;
        }
      }
    }
  }
  .file-list-container {
    background-color: white;
    border-radius: 1.2rem;
    overflow: hidden;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ebebeb;
      padding: 2.6rem 3.6rem;
      .path-name {
        font-size: 2.2rem;
        font-weight: bold;
      }
      .right {
        display: flex;
        align-items: center;
        .search-select {
          font-size: 1.4rem;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .contents-top {
      flex-direction: column;
      height: auto;
      .device-name {
        padding: 2rem 0;
        p {
          font-size: 2rem;
        }
      }
      .device-info {
        flex-direction: column;
        gap: 1.2rem;
        padding: 2rem 1rem;
        p {
          font-size: 1.4rem;
        }
        .user-info {
          flex-direction: column;
          width: 100%;
          align-items: center;
          gap: 1rem;
          span {
          }
          span:nth-child(even) {
            display: none;
          }
        }
      }
    }
    .file-list-container {
      .top {
        flex-direction: column;
        gap: 1rem;
        padding: 2rem 1rem;
        .path-name {
          font-size: 1.6rem;
          span {
            word-break: break-all;
          }
        }
        .right {
          width: 100%;
          > div {
            width: 100%;
            gap: 0.4rem;
            .l {
              .search-select {
              }
            }
            .r {
              width: 100%;
              gap: 0.4rem;
            }
          }
        }
      }
    }
  }
`;

export const TableContainer = styled.div`
  padding: 3.2rem 3.6rem;
  .loading {
    text-align: center;
    font-size: 1.6rem;
    padding: 1.6rem;
    border: 1px solid #ebebeb;
    border-radius: 1.2rem;
  }
  form {
    .table-head-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 2rem;
      .left {
        .table-total-row {
          display: flex;
          align-items: center;
          font-size: 1.6rem;
          color: #555;
          font-weight: 500;
          input[type="checkbox"] {
            width: 1.6rem;
            height: 1.6rem;
          }
        }
      }
      .right {
        .btn-box {
          &.multi {
            display: flex;
            gap: 1.6rem;
            button {
              width: 15.4rem;
            }
          }
          button {
            background-color: #0e322b;
            padding: 1rem 2.4rem;
            color: white;
            border-radius: 0.6rem;
            font-size: 1.6rem;
            font-weight: 500;
            border: none;
            outline: none;
            cursor: pointer;
            opacity: 0.7;

            &:hover {
              opacity: 1;
            }
            &:active {
              transform: scale(0.98);
            }
            &.regist {
              background-color: #30a690;
            }
            &.modify {
              background-color: #2d2d2d;
            }
            &.delete {
              background-color: #ffab40;
            }
          }
        }
      }
    }
    .fixed-height {
      max-height: 55rem;
      overflow-x: auto;
    }
    table {
      width: 100%;
      thead {
        th {
          font-size: 1.5rem;
          color: #2d2d2d;
          background-color: #c1e4de;
          padding: 1.6rem;
          border-bottom: none;
          position: relative;
          span.up {
            display: inline-flex;
            margin-left: 1rem;
            transform: rotate(90deg) translateX(2px);
            img {
              display: flex;
              width: 0.8rem;
            }
          }
          span.down {
            display: inline-flex;
            margin-left: 1rem;
            transform: rotate(270deg) translateX(-2px);
            img {
              display: flex;
              width: 0.8rem;
            }
          }
        }
      }
      th,
      td {
        border-left: 1px solid #ebebeb;
        border-bottom: 1px solid #ebebeb;
      }
      th:first-child,
      td:first-child {
        border-left: none;
      }
      tbody {
        td {
          font-size: 1.5rem;
          font-weight: 400;
          text-align: center;
          padding: 1.8rem;
          color: #555;
          vertical-align: middle;
          input[type="checkbox"] {
            width: 1.6rem;
            height: 1.6rem;
          }
          &.type-folder {
            color: #2d2d2d;
          }
          .clickable-folder {
            color: #1847ed;
            text-decoration: underline;
            cursor: pointer;
          }
          .history-file-name {
            display: -webkit-box;
            min-height: 4.2rem;
            line-height: 2.1rem;
            overflow: hidden;
            text-align: left;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          .download-btn {
            background-color: #0e322b;
            color: white;
            width: 15.4rem;
            padding: 0.9rem;
            border: none;
            outline: none;
            border-radius: 0.4rem;
            opacity: 0.7;
            &:hover {
              opacity: 1;
            }
            &:active {
              transform: scale(0.97);
            }
          }
          .folder-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 2rem;
              display: flex;
              transform: translateY(-2px);
            }
            gap: 0.4rem;
          }
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding: 2rem 1rem;
    form {
      width: 100%;
      overflow: hidden;
      .fixed-height {
        width: 100%; /* 부모 요소의 너비를 100%로 설정 */
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch !important; /* 터치스크린에서 스크롤이 부드럽게 보이도록 설정 */

        table {
          min-width: 1400px;
          width: 100%;
        }
      }
      .table-head-wrap.user-table {
        flex-direction: column;
        .left {
          .table-total-row {
            margin-bottom: 1rem;
          }
        }
        .right {
          .btn-box.multi {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            button {
              width: auto;
            }
          }
        }
      }
    }
  }
`;

export const DownloadListContainer = styled.div`
  .contents-body {
    .user-select-info {
      background-color: white;
      border-radius: 1.2rem;

      display: flex;
      justify-content: space-between;
      align-items: center;
      form {
        display: flex;
        gap: 0.8rem;
        padding: 1.6rem 3.6rem;
        .select-contents {
          font-size: 1.6rem;
          min-width: 30rem;
        }
        .select-btn {
          border: none;
          outline: none;
          background-color: #30a690;
          color: white;
          font-size: 1.4rem;
          width: 12rem;
          border-radius: 0.6rem;
        }
      }
    }
    .btn-box {
      button {
        cursor: pointer;
        min-width: 15.4rem;
        font-size: 1.6rem;
        font-weight: 400;
        letter-spacing: -0.05rem;
        color: white;
        border: none;
        outline: none;
        border-radius: 0.6rem;
        padding: 1rem;
        opacity: 0.6;
        background-color: #ffab40;
        &:hover {
          opacity: 1;
        }
        &:active {
          transform: scale(0.98);
        }
      }
    }
    .download-list-box {
      background-color: white;
      border-radius: 1.2rem;
    }
  }
  @media screen and (max-width: 768px) {
    min-height: 80rem;
    .user-list-top-header {
      width: 100%;
      .l {
        .search-select {
        }
      }
      .r {
        width: 100%;
        gap: 0.4rem;
        > div {
          width: 100%;
          gap: 0.4rem;
          .l {
            .search-select {
            }
          }
          .r {
            width: 100%;
            gap: 0.4rem;
          }
        }
      }
    }
    .contents-body {
      .user-select-info {
        form {
          flex-direction: column;
          padding: 2rem;
          .select-contents {
            min-width: auto;
          }
          .select-btn {
            padding: 1rem;
            width: 100%;
          }
        }
      }
    }
  }
`;

export const UserListContainer = styled.div`
  .contents-body {
    background-color: white;
    border-radius: 1.2rem;
    .report-filter-controls {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1.6rem;
      padding: 2.4rem 3.6rem 0;
      .preset-buttons {
        display: flex;
        align-items: center;
        gap: 0.8rem;
        .custom-date-trigger {
          position: relative;
        }
        .custom-date-summary {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
          height: 3.8rem;
          border: 1px solid #c1e4de;
          border-radius: 0.6rem;
          padding: 0 1rem;
          background-color: #f7fbfa;
          color: #555;
          font-size: 1.4rem;
          white-space: nowrap;
        }
        > button,
        .custom-date-trigger > button {
          min-width: 8.8rem;
          height: 3.8rem;
          border: 1px solid #c1e4de;
          border-radius: 0.6rem;
          background-color: white;
          color: #0e322b;
          font-size: 1.5rem;
          font-weight: 500;
          cursor: pointer;
          &:hover,
          &.active {
            background-color: #30a690;
            color: white;
          }
        }
        .custom-date-popover {
          position: absolute;
          top: calc(100% + 0.8rem);
          left: 0;
          z-index: 20;
          border-radius: 0.8rem;
          background-color: white;
          box-shadow: 0 1rem 3rem rgba(14, 50, 43, 0.18);
          .custom-date-calendar {
            width: 32rem;
            border: 1px solid #c1e4de;
            border-radius: 0.8rem;
            padding: 1rem;
            color: #0e322b;
            font-family: inherit;
            font-size: 1.4rem;
            line-height: 1.4;
            .react-calendar__navigation {
              height: 3.6rem;
              margin-bottom: 0.8rem;
              button {
                min-width: 3.2rem;
                height: 3.6rem;
                border-radius: 0.4rem;
                color: #0e322b;
                font-size: 1.4rem;
              }
            }
            .react-calendar__month-view__weekdays {
              color: #6d6d6d;
              font-size: 1.2rem;
              abbr {
                text-decoration: none;
              }
            }
            .react-calendar__tile {
              min-width: 0;
              height: 3.8rem;
              border-radius: 0.4rem;
              padding: 0;
              color: #0e322b;
            }
            .react-calendar__tile:disabled {
              background-color: #f1f4f3;
              color: #b5b5b5;
            }
            .react-calendar__month-view__days__day--weekend {
              color: #d94f4f;
            }
            .react-calendar__tile--now {
              background-color: #eef8f6;
            }
            .react-calendar__tile--active,
            .react-calendar__tile--rangeStart,
            .react-calendar__tile--rangeEnd {
              background-color: #30a690;
              color: white;
            }
            .react-calendar__tile--range {
              background-color: #dff3ef;
            }
            .react-calendar__tile:enabled:hover,
            .react-calendar__tile:enabled:focus,
            &.react-calendar--selectRange .react-calendar__tile--hover {
              background-color: #c8ebe5;
            }
          }
        }
      }
      .report-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .pdf-download-button {
          min-width: 11.2rem;
          height: 3.8rem;
          border: 1px solid #30a690;
          border-radius: 0.6rem;
          background-color: #30a690;
          color: white;
          font-size: 1.5rem;
          font-weight: 600;
          cursor: pointer;
          &:hover {
            background-color: #258d7a;
          }
          &:disabled {
            border-color: #c7d8d5;
            background-color: #c7d8d5;
            cursor: not-allowed;
          }
        }
      }
    }
    .fixed-height {
      max-height: 55rem;
      overflow: hidden scroll;
    }
  }
  @media screen and (max-width: 768px) {
    .user-list-top-header {
      width: 100%;
      .l {
        .search-select {
        }
      }
      .r {
        width: 100%;
        gap: 0.4rem;
        > div {
          width: 100%;
          gap: 0.4rem;
          .l {
            .search-select {
            }
          }
          .r {
            width: 100%;
            gap: 0.4rem;
          }
        }
      }
    }
    .contents-body {
      .report-filter-controls {
        align-items: stretch;
        flex-direction: column;
        padding: 1.6rem 1rem 0;
        .preset-buttons {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          .custom-date-summary {
            grid-column: 1 / -1;
          }
          .custom-date-trigger {
            .custom-date-popover {
              left: 0;
              right: 0;
              .custom-date-calendar {
                width: 100%;
              }
            }
          }
          > button,
          .custom-date-trigger > button {
            width: 100%;
          }
        }
        .report-actions {
          width: 100%;
          .pdf-download-button {
            width: 100%;
          }
        }
      }
    }
  }
`;

// modal
export const BoxInner = styled.div`
  display: flex;
  flex-direction: column;
  .btn-box {
    display: flex;
    position: relative;
    justify-content: center;
    gap: 1rem;
    padding: 0.8rem 0;
    margin-top: 1rem;
    button {
      cursor: pointer;
      border: 0;
      outline: 0;
      background-color: transparent;
      width: 7.7rem;
      padding: 0.9rem 0;
      font-size: 1.6rem;
      font-weight: 400;
      letter-spacing: -0.05rem;
      color: white;
      border-radius: 0.4rem;
      &.regist {
        background-color: #30a690;
      }
      &.cancel {
        background-color: #0e322b;
      }
      &.delete {
        background-color: #ed2115;
      }
    }
  }
  .column-btn-box {
    padding: 1.6rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    button {
      cursor: pointer;
      border: none;
      outline: none;
      display: flex;
      border-radius: 0.5rem;
      align-items: center;
      justify-content: center;
      &.continue {
        padding: 1.6rem;
        background-color: #225298;
        color: white;
        font-size: 1.6rem;
        line-height: 2.4rem;
        font-weight: 700;
      }
      &.del {
        padding: 0.6rem;
        font-size: 1.4rem;
        line-height: 2rem;
        letter-spacing: -0.06rem;
        font-weight: 500;
        background-color: transparent;
      }
    }
  }
  .modal-header {
    padding: 2rem 2.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #c1e4de;
    p {
      font-size: 2rem;
      color: #555;
      font-weight: 500;
    }
    .closed-modal-btn {
      border: none;
      background-color: transparent;
      outline: none;
    }
  }
  form {
    padding: 3.3rem 2.8rem;
    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1.2rem;
      p {
        font-size: 1.8rem;
        font-weight: 500;
      }
      span {
        font-size: 1.6rem;

        b {
          color: #ed2115;
        }
      }
    }
    table {
      border-top: 2px solid #2d2d2d;
      width: 100%;
      tbody {
        tr {
          th {
            font-size: 1.6rem;
            vertical-align: middle;
            font-weight: 400;
            text-align: left;
            padding: 0.8rem 2.2rem;
            width: 16rem;
            background-color: #f9f9f9;
            b {
              color: #ed2115;
            }
          }
          td {
            padding: 0.8rem;
            text-align: left;
            input[type="text"],
            input[type="password"],
            input[type="email"] {
              width: 100%;
              padding: 0.6rem;
              font-size: 1.4rem;
              border: 1px solid #ebebeb;
              border-radius: 0.2rem;
            }
            input.read-only {
              background-color: #f5f5f5;
            }
            .radio-box {
              display: flex;
              gap: 6rem;
            }
          }
        }
      }
    }
  }
  .del-contents-body {
    padding: 3rem 2.8rem;
    p {
      font-size: 1.6rem;
      margin-bottom: 2rem;
    }
    table {
      border-top: 2px solid #2d2d2d;
      width: 100%;
      margin-bottom: 2rem;
      tbody {
        tr {
          border-bottom: 1px solid #ebebeb;
          th {
            font-size: 1.6rem;
            vertical-align: middle;
            font-weight: 400;
            text-align: left;
            padding: 0.8rem 2.2rem;
            width: 20rem;
            background-color: #f9f9f9;
            b {
              color: #ed2115;
            }
          }
          td {
            padding: 0.8rem;
            text-align: center;
            font-size: 1.6rem;
            border-left: 1px solid #ebebeb;
          }
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .modal-header {
      p {
        font-size: 1.6rem;
      }
    }
    form {
      padding: 2rem;
      .info {
        p {
          font-size: 1.6rem;
        }
      }
      table {
        tbody {
          tr {
            th {
              font-size: 1.4rem;
              width: 13rem;
            }
            td {
              .radio-box {
                flex-direction: column;
                gap: 1rem;
              }
            }
          }
        }
      }
    }
  }
`;

export const SBoxInner = styled.div`
  .modal-header {
    padding: 2rem 2.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #c1e4de;
    p {
      font-size: 2rem;
      color: #555;
      font-weight: 500;
    }
    .closed-modal-btn {
      border: none;
      background-color: transparent;
      outline: none;
    }
  }
  .modal-body {
    padding: 5rem 2.8rem;
    p {
      font-size: 1.6rem;
      white-space: pre-wrap;
      text-align: center;
      line-height: 1.4;
      font-weight: 500;
    }
    .btn-box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 3rem;
      button {
        display: flex;
        padding: 0.8rem 2rem;
        outline: none;
        border: none;
        background-color: #30a690;
        color: white;
        border-radius: 0.4rem;
      }
    }
  }
`;

export const ErrMsg = styled.span`
  padding: 0.8rem 0.8rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  color: #ed2115;
`;
